import { BriefcaseBusiness, CalendarDays } from 'lucide-react';
import { Tooltip } from '@/components/ui/Tooltip';
import { useFilters, type TimeRangeMode } from '@/state/filters';
import { cn } from '@/lib/cn';

interface TimeRangeOption {
  value: TimeRangeMode;
  label: string;
  hint: string;
  icon: React.ComponentType<{ className?: string }>;
}

const OPTIONS: TimeRangeOption[] = [
  {
    value: 'standard',
    label: 'Standard day',
    hint: 'Use calendar days: 00:00 to 23:59.',
    icon: CalendarDays,
  },
  {
    value: 'business',
    label: 'Business day',
    hint: 'Use business days: 06:00 to next-day 05:59.',
    icon: BriefcaseBusiness,
  },
];

export function TimeRangeModeToggle() {
  const timeRangeMode = useFilters((s) => s.timeRangeMode);
  const setTimeRangeMode = useFilters((s) => s.setTimeRangeMode);

  return (
    <div
      role="radiogroup"
      aria-label="Day boundary"
      className="inline-flex items-center gap-0.5 rounded-md bg-muted p-0.5"
    >
      {OPTIONS.map((opt) => {
        const active = timeRangeMode === opt.value;
        const Icon = opt.icon;
        return (
          <Tooltip key={opt.value} content={opt.hint}>
            <button
              type="button"
              role="radio"
              aria-checked={active}
              onClick={() => setTimeRangeMode(opt.value)}
              className={cn(
                'press inline-flex items-center gap-1 rounded-sm px-2 py-1 text-[11px] font-medium transition-colors duration-150 ease-out focus-ring',
                active
                  ? 'bg-surface text-foreground shadow-soft'
                  : 'text-muted-foreground hover:text-foreground',
              )}
            >
              <Icon className="h-3 w-3" aria-hidden />
              <span className="hidden lg:inline">{opt.label}</span>
              <span className="lg:hidden">{opt.value === 'standard' ? 'Std' : 'Biz'}</span>
            </button>
          </Tooltip>
        );
      })}
    </div>
  );
}
